import { Button } from "components/Button/Button";

interface ShowAllButtonProps {
    /** Invoked when the user clicks the link (typically a jump to a pre-filtered advanced search). */
    onClick: () => void;
    /** Optional native tooltip explaining where the link leads. */
    title?: string;
    /** Override the label. Defaults to "Show all" to match the dashboard-widget links. */
    label?: string;
}

/**
 * Canonical "Show all" affordance for list/table headers and toolbars that jump
 * to a pre-filtered advanced search.
 *
 * It deliberately reuses ONE wording ("Show all") and ONE styling (an
 * underlined text-link `Button`, variation "link") so every list view links out
 * consistently — matching the dashboard `Widget` "Show all" header link and the
 * `ReferenceList` "Show all" button, and carrying the canonical navigation-link
 * affordance (underlined link, not inert-looking text) per the
 * affordance-interactivity design principle. Use this instead of a bespoke
 * secondary "Advanced search" button so the pattern stays consistent across
 * list views rather than being a one-off.
 */
export const ShowAllButton = ({ onClick, title, label = "Show all" }: ShowAllButtonProps) => (
    <Button size="small" variation="link" label={label} onClick={onClick} title={title} />
);

export default ShowAllButton;
